module.exports = __webpack_public_path__ + "img/blog-2-1.e12daee4.jpeg";